export default __webpack_public_path__ + "static/media/win_stage_igra.23ebcd09.mp3";